document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.getElementById("custom-popup");
  const step1 = document.getElementById("popup-rebrand-step-1");
  const step2 = document.getElementById("popup-rebrand-step-2");
  const thankYouStep = document.getElementById("popup-thank-you");

  const enterButton = document.getElementById("popup-enter");
  const closeStep1 = document.getElementById("popup-close-step1");
  const closeStep2 = document.getElementById("popup-close-step2");
  const form = document.getElementById("popup-form");
  const emailInput = document.getElementById("popup-email");
  const sourceUrlInput = document.getElementById("popup-source-url"); // Hidden field for source URL
  const thankClose = document.getElementById("popup-thank-close");

  const listID = "XftKEx";
  const POPUP_STORAGE_KEY = "popupDismissed";
  const POPUP_EXPIRY_DAYS = 3; // 0.0001 for testing

  const excludedURLs = [
    "/pages/amazon",
    "/pages/gift",
    "pages/amazon-50-off",
    "/pages/amazon-50-off",
    "/pages/new-scent-preorder",
    "/pages/qr-v3-shipper",
    "/pages/vday",
    "/pages/cnc",
    "/pages/links",
    "/cart"
  ]; // Array of URLs to exclude

  // Set the source URL in the hidden field
  if (sourceUrlInput) {
    sourceUrlInput.value = window.location.href; // Capture the current URL
  }

  // Check if popup should be hidden on excluded URLs
  const pathname = window.location.pathname;
  const isExcludedPath = excludedURLs.includes(pathname);
  const isLoopSubscriptionsPath = pathname.includes("loop_subscriptions");

  if (isExcludedPath || isLoopSubscriptionsPath) {
    return; // Stop further execution of the script
  }

  // Function to track popup impressions in Google Analytics
  function trackPopupImpression() {
    if (window.gtag) {
      gtag("event", "popup_impression", {
        event_category: "Custom Popup",
        event_label: "Free Bottle Popup REBRAND",
        value: 1,
      });
    }
  }

  // Function to track popup submissions in Google Analytics
  function trackPopupSubmission() {
    if (window.gtag) {
      gtag("event", "popup_submission", {
        event_category: "Custom Popup",
        event_label: "Free Bottle Popup REBRAND",
        value: 1,
      });
    }
  }

  // Check if visitor is a known Klaviyo subscriber via __kla_id cookie
  function isKlaviyoSubscriber() {
    try {
      const match = document.cookie.match(/__kla_id=([^;]*)/);
      const value = match ? match[1].trim() : null;
      if (!value) return false;

      const decoded = atob(value);
      const data = JSON.parse(decoded);
      return !!(data && data.$email);
    } catch {
      return false;
    }
  }

  // Function to check if popup should show
  function shouldShowPopup() {
    if (isKlaviyoSubscriber()) return false;

    const dismissedTime = localStorage.getItem(POPUP_STORAGE_KEY);
    if (!dismissedTime) return true;

    const currentTime = new Date().getTime();
    const expiryTime = parseInt(dismissedTime, 10) + POPUP_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

    return currentTime > expiryTime;
  }

  // Hide popup and set local storage
  function hidePopupFor3Days() {
    popupOverlay.style.display = "none";
    const currentTime = new Date().getTime();
    localStorage.setItem(POPUP_STORAGE_KEY, currentTime);
  }

  // Show popup after 2 seconds if conditions allow
  if (shouldShowPopup()) {
    setTimeout(() => {
      popupOverlay.style.display = "flex";
      trackPopupImpression();
    }, 2000); // change to 1 for testing
  }

  // Step 1 -> Step 2 with slide-in effect
  enterButton.addEventListener("click", () => {
    step1.classList.add("slide-out"); // Add slide-out class to Step 1
    step1.addEventListener(
      "transitionend",
      () => {
        step1.classList.remove("active", "slide-out"); // Remove active and slide-out classes
        step2.classList.add("active"); // Activate Step 2
      },
      { once: true } // Ensure the listener is triggered only once
    );
  });

  // AJAX form submission
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const email = emailInput.value;
    const sourceUrl = sourceUrlInput.value;

    if (!email || !email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        g: listID,
        email: email,
        source_url: sourceUrl, // Include the source URL in the submission
      }),
    })
      .then((response) => {
        if (response.ok) {
          form.style.display = "none";
          thankYouStep.classList.add("active");

          // Track popup submission in Google Analytics
          trackPopupSubmission();

          // Fallback so popup won't show again if __kla_id cookie isn't set yet this session
          localStorage.setItem(POPUP_STORAGE_KEY, new Date().getTime());
        } else {
          alert("There was an error submitting your email. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("There was an error submitting your email. Please try again.");
      });
  });

  // Close popup and hide for 3 days
  closeStep1.addEventListener("click", hidePopupFor3Days);
  closeStep2.addEventListener("click", hidePopupFor3Days);
  thankClose.addEventListener("click", hidePopupFor3Days);

  popupOverlay.addEventListener("click", function (e) {
    if (e.target === popupOverlay) {
      hidePopupFor3Days();
    }
  });
});
